<script setup lang="ts">
import { computed, ComputedRef, inject, ref } from 'vue';

import { TSDataTable, TSDialogReportTag } from 'tsv2-library';
import { MenuOption } from 'tsv2-library/dist/src/components/v2/Menu/Menu.vue';

import {
  childColumns,
  returnColumns,
} from '@/components/common/options/columns';
import RemoveFromList from '../BorrowExtension/Dialog/RemoveFromList.vue';

import useTableStore from '@/store/table.store';

import { BorrowingBorrowedReturnAsset } from '@/types/borrowing.type';

const { tableKey } = useTableStore();

const isLinkedAsset = inject('isLinkedAsset') as ComputedRef<boolean>;

const selectedData = defineModel<BorrowingBorrowedReturnAsset[]>(
  'selectedData',
  {
    required: true,
  },
);

defineProps<{
  data: BorrowingBorrowedReturnAsset[];
  filters: Record<string, object>;
  search?: string;
}>();

defineEmits<{
  reported: [];
}>();

const selectedDatum = ref<BorrowingBorrowedReturnAsset>();

const columns = returnColumns();
const childrenColumns = childColumns(true);

const showRemoveFromList = ref<boolean>(false);
const showReportTAG = ref<boolean>(false);

const singleOptions = computed<MenuOption[]>(() => {
  const options: MenuOption[] = [
    {
      label: 'Report TAG',
      icon: 'report-tag',
      visible: !selectedDatum.value?.isVerified,
      command: (): void => {
        showReportTAG.value = true;
      },
    },
    {
      label: 'Remove from List',
      icon: 'delete-bin',
      visible: true,
      danger: true,
      command: (): void => {
        showRemoveFromList.value = true;
      },
    },
  ];
  return options.filter((col) => col.visible);
});

const childrenSingleOptions = computed<MenuOption[]>(() => {
  const options: MenuOption[] = [
    {
      label: 'Report TAG',
      icon: 'report-tag',
      visible:
        !selectedDatum.value?.isVerified &&
        selectedDatum.value?.status !== 'TAG Reported',
      command: (): void => {
        showReportTAG.value = true;
      },
    },
  ];
  return options.filter((col) => col.visible);
});
</script>
<template>
  <div data-ts-name="borrow-return-table">
    <RemoveFromList
      v-model:visible="showRemoveFromList"
      :selected-data="selectedDatum ? [selectedDatum] : []"
    />
    <TSDialogReportTag
      :id="selectedDatum ? selectedDatum.asset : ''"
      v-model:visible="showReportTAG"
      @reported="$emit('reported')"
    />
    <TSDataTable
      :key="tableKey"
      v-model:selected-data="selectedData"
      :children-columns="isLinkedAsset ? childrenColumns : undefined"
      :children-options="childrenSingleOptions"
      :columns
      :data
      :filters
      :options="singleOptions"
      :rows="10"
      :search
      :use-paginator="false"
      @toggle-children-option="selectedDatum = $event"
      @toggle-option="selectedDatum = $event"
      data-key="_id"
      selection-type="checkbox"
      table-name="borrow-return-table"
    />
  </div>
</template>
